// extracted by mini-css-extract-plugin
module.exports = {"social-follow":"styles-m__social-follow__OfwIW","social-link":"styles-m__social-link__1Unn3"};